import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient, type GraphQLResult } from "aws-amplify/api";
import { refreshRestaurants as refreshRestaurantsMutation } from "@/graphql/mutations";
import { GraphQLError } from "graphql";

const client = generateClient();

export const refreshRestaurantsState = create<State<boolean | null>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const refreshRestaurantsIsloading = () =>
  refreshRestaurantsState.setState(() => ({
    isLoading: true,
    isFetching: false,
    data: null,
    error: null,
  }));
export const refreshRestaurantsIsError = (error: GraphQLError[] | undefined) =>
  refreshRestaurantsState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
    isFetching: false,
  }));
export const refreshRestaurantsIsSuccess = (queryResult: boolean) =>
  refreshRestaurantsState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
    isFetching: false,
  }));

export const resetRefreshRestaurantsState = () =>
  refreshRestaurantsState.setState(() =>
    refreshRestaurantsState.getInitialState(),
  );

type RefreshRestaurantsParams = {
  restaurantIds: string[];
};

export const refreshRestaurants = async (params: RefreshRestaurantsParams) => {
  refreshRestaurantsIsloading();
  const { restaurantIds } = params;

  try {
    const { data } = await client.graphql({
      query: refreshRestaurantsMutation,
      variables: {
        restaurantIds,
      },
    });

    refreshRestaurantsIsSuccess(data.refreshRestaurants);
  } catch (e) {
    const graphQl = e as GraphQLResult<boolean>;
    refreshRestaurantsIsError(graphQl.errors);
  }
};
